import { render, staticRenderFns } from "./GoldScheme.vue?vue&type=template&id=229c5397&"
import script from "./GoldScheme.vue?vue&type=script&lang=js&"
export * from "./GoldScheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports